<template>
  <el-dialog :title="(model.id > 0 ? '编辑' : '添加') + '客户设备'" :visible.sync="visible" :close-on-click-modal="false" width="960px" @close="$emit('update:show', false)" @open="opend" append-to-body>
    <el-form :model="model" :rules="formRules" ref="form" label-width="100px" size="small" class="form-flex">
      <el-form-item label="序列号" prop="serial_number">
        <el-input style="width: 100%" size="small" v-model="model.serial_number" placeholder="请输入设备序列号" @blur="checkSerialNumber" :disabled="serialNumberDisabled"></el-input>
        <template v-if="existDevice">
          <div class="text-danger exist-info">序列号已存在</div>
          <template v-if="auth.isPlatformUser()">
            <div class="exist-info" v-if="existDevice && existDevice.customer_id > 0">客户：{{ existDevice.customer.name }}</div>
            <!-- <div>
              <router-link
                :to="{
                  path: '/dashboard/admin/customer_devices/merge',
                  query: {
                    cid: model.id,
                    tid: existDevice.id,
                    customer_id: model.customer_id,
                  },
                }"
                >前往处理重复设备</router-link
              >
            </div> -->
          </template>
        </template>
      </el-form-item>
      <el-form-item label="铭牌照片" prop="name_plate">
        <div class="name_plate_container">
          <div class="flex-row-between name-plate" v-if="model.name_plate && model.name_plate.length > 0">
            <viewer class="viewer" ref="viewer">
              <template>
                <auth-img tag="el-image" style="width: 16px; height: 16px; margin-left: 5px" :src="model.name_plate" :preview-src-list="[model.name_plate]" />
              </template>
            </viewer>
            <el-button size="mini" type="text" icon="el-icon-close" @click="handleRemove()">删除</el-button>
          </div>

          <el-upload class="avatar-uploader" :action="uploadUrl" :limit="1" accept="image/*" ref="uploader" :show-file-list="false" :headers="uploadHeader" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleUploadError" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="设备号" prop="equipment_number">
        <el-input style="width: 100%" size="small" v-model="model.equipment_number" placeholder="请输入设备号" @input="getDeviceInfoByEquipmentNumber"></el-input>
        <div class="text-info exist-info" v-if="!model.id && model.description">描述：{{ model.description }}</div>
      </el-form-item>
      <el-form-item label="中间商" v-if="auth.isPlatformUser()">
        <customer-select style="width: 100%" :val="model.sold_customer_id" @change="model.sold_customer_id = $event"></customer-select>
      </el-form-item>
      <el-form-item label="OEM厂商" v-if="auth.isPlatformUser()">
        <customer-select style="width: 100%" :val="model.oem_customer_id" @change="model.oem_customer_id = $event"></customer-select>
      </el-form-item>
      <el-form-item label="最终客户" prop="install_customer_id">
        <customer-select ref="customerSelect" :disabled="fixedCustomer && fixedCustomer.id > 0" style="width: 100%" :val="model.install_customer_id" @change="model.install_customer_id = $event" :add="true"></customer-select>
      </el-form-item>
      <el-form-item label="泵油类型" size="small" prop="oil_type">
        <el-input size="small" v-model="model.oil_type" placeholder="请输入泵油类型"></el-input>
      </el-form-item>
      <!-- <el-form-item label="机型分类" prop="item_category_id">
        <item-category-select
          :val="model.item_category_id"
          :valName="model.item_category ? model.item_category.name : ''"
          :category="2"
          @change="model.item_category_id = $event"
        ></item-category-select>
      </el-form-item> -->
      <!-- <el-form-item label="机器型号">
        <el-input
          style="width: 100%"
          size="small"
          v-model="model.machine_type"
          placeholder="请输入设备机器型号"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="设备工况">
        <el-select size="small" style="width: 100%" v-model="model.working_condition" placeholder="请选择设备工况">
          <el-option v-for="item in conditions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运行时长">
        <el-input style="width: 100%" size="small" v-model.number="model.running_time" type="number" placeholder="运行时长"> </el-input>
        <!-- <el-select
          size="small"
          style="width: 100%"
          v-model="model.running_time"
          placeholder="请选择设备运行时长"
        >
          <el-option
            v-for="item in times"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="发货日期">
        <el-date-picker size="small" style="width: 100%" v-model="model.purchase_time" type="date" placeholder="请选择发货日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="完保日期">
        <el-date-picker size="small" style="width: 100%" v-model="model.last_maintenance_date" type="date" placeholder="请选择完保日期" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

      <el-form-item label="公司产品" prop="product_name" v-if="auth.isPlatformUser()">
        <el-input style="width: 100%" size="small" v-model="model.product_name" placeholder="公司产品"></el-input>
      </el-form-item>
      <el-form-item label="应用" prop="product_application" v-if="auth.isPlatformUser()">
        <DeviceApplicationSelect v-model="model.product_application"></DeviceApplicationSelect>
      </el-form-item>
      <el-form-item label="工艺" prop="craft" v-if="auth.isPlatformUser()">
        <DeviceCraftSelect v-model="model.craft" :application="model.product_application"></DeviceCraftSelect>
      </el-form-item>
      <el-form-item label="所在区县" size="small" v-if="showAddress">
        <el-cascader style="width: 100%" size="small" class="long" :props="{ checkStrictly: true }" :options="regionData" v-model="model.area"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" size="small" prop="address_detail" v-if="showAddress">
        <el-input size="small" v-model="model.address.detail" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="model.status" size="small" placeholder="请选择" style="width: 100%">
          <el-option v-for="(value, index) in CustomerDeviceStatusMap" :key="index" :label="value" :value="parseInt(index)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" size="small" prop="desc">
        <el-input size="small" v-model="model.desc" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>

    <el-dialog v-if="existDevice" width="420px" title="序列号已存在" :visible.sync="innerVisible" append-to-body>
      <div class="text-info-12">序列号{{ existDevice.serial_number }}已被中间商{{ existDevice.dealer.name }}使用。</div>
      <div>
        是否将本设备所属客户
        <span class="text-primary">{{ customer.name }}</span>
        绑定至中间商
        <span class="text-primary">{{ existDevice.dealer.name }}</span
        >，并将续序列号为 <span class="text-primary">{{ existDevice.serial_number }}</span
        >的设备绑定给此客户 ?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="innerVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="rebindCustomerDevice">绑 定</el-button>
      </span>
    </el-dialog>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { createCustomerDevice, updateCustomerDevice, itemList, itemCategoryList, customerDeviceExist, customerInfo, updateCustomerDeviceRebind, customerDeviceGroupDetail } from '../service/getData'
import store from '@/store/store'
import { urlPerfix, host, thumbnailImagePath, originImagePath } from '@/config/env'
import ItemCategorySelect from '@/components/select/item_category_select'
import CustomerSelect from '@/components/select/customer_select'
import DealerSelect from '@/components/select/dealer_select'
import DeviceCraftSelect from '@/components/select/device_craft_select'
import DeviceApplicationSelect from '@/components/select/device_application_select'

import { DeviceWorkConditions, DeviceRunTimes, CustomerDeviceStatusMap } from '@/config/global'

import auth from '@/util/auth'

export default {
  components: {
    ItemCategorySelect,
    CustomerSelect,
    DealerSelect,
    DeviceCraftSelect,
    DeviceApplicationSelect,
  },
  props: {
    model: {
      type: Object,
    },
    customerName: {
      type: String,
    },
    fixedCustomer: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    showAddress: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.fileList = []
      } else {
        if (this.showAddress) {
          this.model.area = []
          if (this.model.address.province) {
            this.model.area.push(this.model.address.province)
          }
          if (this.model.address.city) {
            this.model.area.push(this.model.address.city)
          }
          if (this.model.address.county) {
            this.model.area.push(this.model.address.county)
          }
        }
      }
    },
    model() {
      if (this.model.id > 0) {
        this.categories = [this.model.item_category]
      }
    },
  },
  data() {
    return {
      regionData,
      auth,
      host,
      CustomerDeviceStatusMap,
      thumbnailImagePath,
      originImagePath,
      visible: this.show,
      uploadUrl: urlPerfix + '/images/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      customer: null,
      innerVisible: false,
      formRules: {
        install_customer_id: [
          { required: true, message: '请选择最终客户', trigger: 'change' },
          { type: 'number', min: 1, message: '请选择最终客户' },
        ],
        item_category_id: [
          { required: true, message: '请选择设备分类', trigger: 'blur' },
          { type: 'number', message: '请选择设备分类' },
        ],
        serial_number: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }],
        equipment_number: [
          { required: true, message: '请输入设备号', trigger: 'blur' },
          { type: 'string', message: '请输入设备号' },
        ],
        purchase_time: [
          { required: true, message: '请选择发货日期', trigger: 'blur' },
          { type: 'date', message: '请选择发货日期' },
        ],
      },
      loading: false,
      conditions: DeviceWorkConditions,
      times: DeviceRunTimes,
      categories: [],
      fileList: [],
      existDevice: null,
      serialNumberDisabled: false,
    }
  },
  created() {},
  methods: {
    submitForm() {
      if (this.existDevice) {
        return
      }

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.showAddress) {
            this.model.address.province = this.model.area[0] || ''
            this.model.address.city = this.model.area[1] || ''
            this.model.address.county = this.model.area[2] || ''
          }

          if (this.model.id > 0) {
            let res = await updateCustomerDevice(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCustomerDevice(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async requestDeviceCategories(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          query: query,
          page: 0,
          size: 10,
          category: 2,
        }
        let res = await itemCategoryList(data)
        this.loading = false
        this.categories = res.data.list
      } else {
        this.categories = []
      }
    },
    async checkSerialNumber() {
      return
      if (this.model.serial_number.length > 0) {
        let res = await customerDeviceExist({
          serial_number: this.model.serial_number,
        })
        if (res.data.id > 0) {
          this.existDevice = res.data
        } else {
          this.existDevice = null
        }
      }
    },

    async getDeviceInfoByEquipmentNumber() {
      if (!this.model.id && this.model.equipment_number) {
        let res = await customerDeviceGroupDetail({
          number: this.model.equipment_number,
        })

        if (res.data.id) {
          this.model.description = res.data.description
        } else {
          this.model.description = ''
        }
      }
    },
    async requestCustomerInfo() {
      let res = await customerInfo(this.model.customer_id)
      if (res.code == 0) {
        this.customer = res.data
      }
    },
    async rebindCustomerDevice() {
      let data = {
        customer_id: this.customer.id,
        dealer_id: this.existDevice.dealer_id,
        customer_device_id: this.existDevice.id,
      }
      let res = await updateCustomerDeviceRebind(data)
      if (res.code == 0) {
        this.$message.success('绑定成功')
        this.innerVisible = false
        this.visible = false
      }
    },
    opend() {
      if (this.model.id > 0) {
        if (!!this.model.serial_number && !auth.isPlatformUser()) {
          this.serialNumberDisabled = true
        }
        const date = new Date(this.model.purchase_time)
        if (date.getTime() <= 0) {
          this.model.purchase_time = null
        }
      }

      if (this.$refs.uploader) {
        this.$refs.uploader.clearFiles()
      }

      this.existDevice = null
      if (this.model.customer_id > 0 && !this.fixedCustomer) {
        this.requestCustomerInfo()

        let that = this
        setTimeout(() => {
          that.$refs.customerSelect.requestDefaultCustomer()
        }, 200)
      }

      if (this.fixedCustomer) {
        this.customer = this.fixedCustomer
      }
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.name_plate = res.data
      }
      this.$refs.uploader.clearFiles()
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.image
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.image}MB!`)
      }
      return isLimitSize
    },
    handleRemove() {
      this.model.name_plate = null
      this.$refs.uploader.clearFiles()
    },
  },
}
</script>

<style scoped>
.name-plate {
  width: 100%;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  background: #f0f0f0;
  /* padding: 5px; */
  border-radius: 3px;
  margin-right: 10px;
  padding-right: 5px;
}

.exist-info {
  font-size: 12px;
  margin-top: 5px;
  line-height: 1.5;
}

.name_plate_container {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 767px) {
  .name_plate_container {
    display: block;
  }

  .name-plate {
    margin-bottom: 10px;
    padding: 5px;
  }
}
</style>
